import { render, staticRenderFns } from "./scrapGoodsStepList.vue?vue&type=template&id=9c65b774&scoped=true"
import script from "./scrapGoodsStepList.vue?vue&type=script&lang=js"
export * from "./scrapGoodsStepList.vue?vue&type=script&lang=js"
import style0 from "./scrapGoodsStepList.vue?vue&type=style&index=0&id=9c65b774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c65b774",
  null
  
)

export default component.exports